import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxrefund';
export const route = 'cnxrefund/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxrefund" */
/* webpackPrefetch: true */
'../components/RefundPage')));